/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import HowItWorksSectionBase from "../../Common/HowItWorksSection/HowItWorksSectionBase";
import PenIcon from "../../../../assets/icons/traffic/toggleable/IconWriting";
import IncomingCallIcon from "../../../../assets/icons/traffic/toggleable/IconIncomingCall";
import HandshakeIcon from "../../../../assets/icons/traffic/toggleable/IconShakeHands";
const HowItWorksSectionTraffic = () => {
  return (
    <HowItWorksSectionBase
      sections={[
        {
          title: "1. Fall beschreiben",
          description: "Sie füllen innerhalb von 5 Minuten das Formular aus und laden den Bescheid hoch.",
          icon: PenIcon,
        },
        {
          title: "2. Vorgehen besprechen",
          description: "Wir prüfen Ihren Fall und rufen Sie direkt an.",
          icon: IncomingCallIcon,
        },
        {
          title: "3. Einspruch einlegen",
          description: "Wir kümmern uns um alles Weitere.",
          icon: HandshakeIcon,
        },
      ]}
    />
  );
};

export default HowItWorksSectionTraffic;
